"use client"

import { usePathname } from "next/navigation"
import { GoodEndingNav } from "./GoodEndingNav"
import { MAIN_CONTENT_GRID_CLASSES, NAV_RIGHT_FROM_BAND_CSS } from "./mainContentGridClasses"
import { AUTHORS } from "./authors"

// On an individual supplement page the header text ("AI 2040") must line up with
// the essay's content column. The header grid area already starts at the content
// column's left edge, so the only gap is the same horizontal shift the content
// column's text gets (--supplement-content-shift); this class re-applies it to
// the header row. See `.supplement-header-row` in globals.css.
const SUPPLEMENT_HEADER_ROW_CLASS = "supplement-header-row"

export const GoodEndingSiteHeader = () => {
  const pathname = usePathname()

  const isSupplementPage = pathname === "/supplements" || pathname === "/supplementsB"
  const hasCompactHeader =
    pathname.startsWith("/supplements/") ||
    pathname === "/companies-widget" ||
    pathname === "/summary"
  // On the main Plan A page, pin the nav's right edge to the HUD's right edge at
  // every viewport width by absolutely positioning it at NAV_RIGHT_FROM_BAND_CSS
  // (which mirrors the HUD's own `right`, including the narrow-screen clamps).
  // Supplement pages have no HUD, so the nav stays in flow, flush with the
  // content's right edge (md:static + md:justify-between).
  const alignNavToHud = !isSupplementPage && !hasCompactHeader

  return (
    <header className="[grid-area:header]">
      <div
        className={`text-good-ending-foreground ${
          hasCompactHeader ? SUPPLEMENT_HEADER_ROW_CLASS : ""
        }`}
      >
        {/* On supplement page the left column is just "AI 2040" (no big
            title <h1>), so center it against the nav to put them on one line; on
            the main/index pages the tall <h1> sits below "AI 2040", so keep
            top-alignment there. */}
        <div
          className={`relative mt-0 md:mt-4 md:flex md:justify-between ${
            hasCompactHeader ? "md:items-center" : "md:items-start"
          }`}
        >
          <div className="min-w-0">
            <h2 className="text-2xl md:text-[24px] mt-2 md:mt-4 mb-0 uppercase">
              <a href="/" className="no-underline">AI 2040</a>
            </h2>
              {!hasCompactHeader && <h1 className="text-6xl md:text-[65px] mt-0 md:mt-2 mb-2">
                {isSupplementPage ? "Supplements" : "Plan A"}
              </h1>}
          </div>
          {/* Mobile: `absolute right-0 top-0` (flush with the edge — the mobile
              nav is a hamburger). Desktop main page: stay absolute and pin the
              right edge to the HUD via --nav-right; on supplement pages fall back
              to `md:static` so the flex row's justify-between keeps it flush. */}
          <div
            className={`absolute right-0 top-0 ${alignNavToHud ? "md:right-[var(--nav-right)]" : "md:static"}`}
            style={alignNavToHud ? ({ ["--nav-right" as string]: NAV_RIGHT_FROM_BAND_CSS }) : undefined}
          >
            <GoodEndingNav />
          </div>
        </div>
        {(isSupplementPage || hasCompactHeader) ? null : (
          <div className={MAIN_CONTENT_GRID_CLASSES}>
            <h2
              className="text-[1.2rem] md:text-[1.2rem] leading-[1.45] md:text-xl
                md:leading-normal mt-0 mb-6 md:mb-0 tracking-[-0.9px]"
            >
              {AUTHORS.map((author, authorIndex) => (
                <span key={author}>
                  <span className="text-nowrap">{author}</span>
                  {authorIndex < AUTHORS.length - 1 ? ", " : ""}
                </span>
              ))}
            </h2>
          </div>
        )}
      </div>
    </header>
  )
}
